import React, { useEffect, useState } from "react";
import { axiosapi } from "../api/axiosapi";
import BookingModal from "../Components/BookingModal";
import BusCardComponent from "../Components/BusCardComponent";

const BusSearchPage = (props) => {
  return (
    <>
      {props.busesarray.busesarray.map((x) => (
        <BusCardComponent
          removeSeats={props.removeSeats}
          busdata={x}
          busBooking={props.bookingarray.bookingarray}
          addNewBooking={props.addNewBooking}
          newBooking={props.newBooking}
          addBoardingPoint={props.addBoardingPoint}
          addDroppingPoint={props.addDroppingPoint}
          journeyDetails={props.journeyDetails}
          userid={props.userid}
          addSeatToArray={props.addSeatToArray}
          clearBookingState={props.clearBookingState}
          addContactDetails={props.addContactDetails}
          updateSeatWithPerson={props.updateSeatWithPerson}
        />

      ))}

    </>
  );
};

export default BusSearchPage;
